import React from 'react'
import Btn from './Btn'
import { ReactSVG } from 'react-svg'

interface IProps {
  className?: string
  text: string
  limit: number
}

function ExpandedText(props: IProps): React.ReactElement {
  const [expanded, setExpanded] = React.useState<boolean>(false)
  const overLimit = React.useMemo(() => {
    return props.text.length > props.limit
  }, [props.text, props.limit])
  const text = React.useMemo(() => {
    if (!expanded && overLimit) {
      return props.text.slice(0, props.limit) + '...'
    }

    return props.text
  }, [expanded])
  const btnText = React.useMemo(() => {
    if (expanded) {
      return 'Скрыть'
    }

    return 'Читать полностью'
  }, [expanded])

  return (
    <div className={`expanded-text ${props.className ?? ''}`.trim()}>
      <p className={'expanded-text__text'}>{text}</p>

      {overLimit && (
        <div className={'expanded-text__controls'}>
          <Btn
            className={expanded ? '_active' : ''}
            small
            text
            onClick={() => {
              setExpanded(!expanded)
            }}
          >
            <span>{btnText}</span>
            <ReactSVG src={'/i/svg/chevron-down.svg'} wrapper={'span'} />
          </Btn>
        </div>
      )}
    </div>
  )
}

export default ExpandedText
